import { render, staticRenderFns } from "./DatatableNormalPack.vue?vue&type=template&id=008a04f3"
import script from "./DatatableNormalPack.vue?vue&type=script&lang=js"
export * from "./DatatableNormalPack.vue?vue&type=script&lang=js"
import style0 from "./DatatableNormalPack.vue?vue&type=style&index=0&id=008a04f3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports